import { useEffect, useState } from 'react';

import { auth } from '../config';
import { useAuthState } from '../state';
import { AdminPermission, CustomClaims } from '../types';

export const usePermissions = () => {
  const { currentUser } = useAuthState();
  const [customClaims, setCustomClaims] = useState<CustomClaims>({});

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      if (!firebaseUser || !currentUser) {
        setCustomClaims({});
        return;
      }

      try {
        const idTokenResult = await firebaseUser.getIdTokenResult();
        const claims: CustomClaims = {
          isAdmin: idTokenResult.claims.isAdmin as boolean | undefined,
          isHotelspotAdmin: idTokenResult.claims.isHotelspotAdmin as boolean | undefined,
          adminPermission: idTokenResult.claims.adminPermission as AdminPermission | undefined,
        };

        setCustomClaims(claims);
      } catch (error) {
        console.error('Error fetching custom claims:', error);
        setCustomClaims({});
      }
    });

    return () => unsubscribe();
  }, [currentUser]);

  const { adminPermission } = customClaims;

  return {
    isAdmin: customClaims.isAdmin === true,
    isHotelspotAdmin: customClaims.isHotelspotAdmin === true,
    adminPermission,
    /** Konto widzi tylko organizacje i atrakcje, w trybie do odczytu. */
    isOnlyAttraction: adminPermission === 'onlyAttraction',
    /** Konto widzi tylko zgłoszenia. */
    isOnlySupport: adminPermission === 'onlySupport',
    /** Konto widzi tylko pulpit i generator reklam. */
    isOnlyAdsGenerator: adminPermission === 'onlyAdsGenerator',
  };
};
